import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAUGh0NIagIsTcE3BJsJMPHNBWkDc1yl_E",
  authDomain: "facebook-clone-a8100.firebaseapp.com",
  databaseURL: "https://facebook-clone-a8100.firebaseio.com",
  projectId: "facebook-clone-a8100",
  storageBucket: "facebook-clone-a8100.appspot.com",
  messagingSenderId: "1000150882234",
  appId: "1:1000150882234:web:4952e0ecbaf28ecf6fef83",
  measurementId: "G-78C0N9WD7R",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
